import { Navigate, Outlet } from 'react-router';
import { COMMUNICATIONS_APPROVE } from './access';
import { useCommunicationsPermissions } from './use-communications-permissions';

/**
 * The route half of `COMMUNICATIONS_GATE`: without `communications:approve` the caller goes to the
 * dashboard; while the permission is being read nothing renders. Convenience only: the API decides.
 */
export function CommunicationsGate() {
  const permissions = useCommunicationsPermissions();
  if (permissions.status === 'loading') return null;
  const open =
    permissions.status === 'ready' && permissions.permissions.includes(COMMUNICATIONS_APPROVE);
  return open ? <Outlet /> : <Navigate to="/" replace />;
}
